import type { FormRule } from 'antd';

/**
 * API'deki `ParolaKurali` ile birebir: en az 8 karakter, bir büyük harf, bir küçük harf,
 * bir rakam. Harf sınıfları Unicode: "Şifre123" geçerlidir.
 */
export const PAROLA_KURALI_IPUCU =
  'En az 8 karakter; en az bir büyük harf, bir küçük harf ve bir rakam.';

export function parolaKuralaUyuyor(parola: string): boolean {
  return (
    parola.length >= 8 &&
    /\p{Lu}/u.test(parola) &&
    /\p{Ll}/u.test(parola) &&
    /[0-9]/.test(parola)
  );
}

export const parolaKuraliRule: FormRule = {
  validator(_, value?: string) {
    if (!value || parolaKuralaUyuyor(value)) return Promise.resolve();
    return Promise.reject(new Error(PAROLA_KURALI_IPUCU));
  },
};
